import React, { Component } from 'react';
import { Button, Modal, Input, Form, Row, Col } from 'antd';
import styles from './user-settings.module.sass';
import { formatEmail } from '../../../../redux/utils/email';

class DetailsModal extends Component {
  constructor(props) {
    super(props);
    this.form = React.createRef();
  }

  handleSubmit = async () => {
    try {
      const data = this.form.current.getFieldsValue();
      await this.form.current.validateFields();
      this.props.onSubmit(data);
    } catch (err) {
      // console.error(err);  // Security Risk: refs #SC-195
    }
  };

  handleChange = (values) => {
    if (values?.email) {
      this.form.current.setFieldsValue({
        email: formatEmail(values.email),
      });
    }
  };

  renderCreateEmailForm = () => {
    const { user } = this.props;
    return (
      <Form
        layout="vertical"
        className={styles.form}
        ref={this.form}
        onValuesChange={this.handleChange}
        initialValues={
          user
            ? {
                first_name: user.first_name,
                last_name: user.last_name,
                email: user.email,
                group: user.group,
                department: user.department,
              }
            : {}
        }
      >
        <Row>
          <Col span={12}>
            <Form.Item
              label="First Name"
              rules={[
                {
                  required: true,
                  message: 'First Name is required',
                },
              ]}
              name="first_name"
            >
              <Input name="first_name" />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Last Name"
              rules={[
                {
                  required: true,
                  message: 'Last Name is required',
                },
              ]}
              name="last_name"
            >
              <Input name="last_name" />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              label="E-mail"
              rules={[
                {
                  required: true,
                  message: 'Email is required',
                },
              ]}
              name="email"
            >
              <Input name="email" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    );
  };

  render() {
    const { show, user } = this.props;
    if (!show) return null;
    return (
      <Modal
        title={user ? 'Edit User' : 'Create User'}
        className={styles.modal}
        visible
        onCancel={this.props.onCancel}
        footer={[
          <Button key="cancel" onClick={this.props.onCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={this.handleSubmit}>
            {user ? 'Update Account' : 'Invite User'}
          </Button>,
        ]}
      >
        {this.renderCreateEmailForm()}
      </Modal>
    );
  }
}

export default DetailsModal;
